import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
    transform<T>(items: T[], field: string, value: string): T[] {
        return items.filter((item) => item[field].toLowerCase().includes(value.toLowerCase()));
    }
}
